import React from 'react'

import ButtonBase, { ButtonBaseProps } from '../ButtonBase/ButtonBase'
import ButtonContent, { ButtonContentProps } from '../ButtonContent/ButtonContent'


export type SimpleButtonProps = ButtonBaseProps & ButtonContentProps

const SimpleButton: React.FunctionComponent<SimpleButtonProps> = (props) => {
  const { children, title, size, loading, loadingMessage, noPadding, ...rest } = props

  return (
    <ButtonBase size={size} {...rest}>
      <ButtonContent {...{ children, title, size, loading, loadingMessage, noPadding }} />
    </ButtonBase>
  )
}


SimpleButton.defaultProps = {
  size: 'md',
}


export default SimpleButton
